export default {
  path: '/submit',
  title: ' 在线投稿',
  icon: 'wpforms',
  hideSub: true,
  children: (pre => [
    { path: `${pre}topic`, title: '选题管理', icon: 'newspaper-o' },
    { path: `${pre}topic-review`, title: '选题申报', icon: 'location-arrow' },
    { path: `${pre}topic-review`, title: '选题审核', icon: 'file-word-o' }
  ])('/cep/')
}
